import type { IconSvgObject } from './types';

const ArrowDownDoubleIcon: IconSvgObject = [
  ["path", { d: "M17.999 12.4999L11.999 18.4999L5.99898 12.4999", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M17.9993 5.49951L11.9994 11.4995L5.99932 5.49956", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default ArrowDownDoubleIcon;
